import styled from 'styled-components';
import { typography } from 'dab-component-lib';
import { MediaStyle, GridRowStyle, GridColStyle, basic, status } from '../../utils/style-utils';


export const TitleStyle = styled.h3`
  ${typography.Headline1}
  color: ${basic.secondary};
  ${ MediaStyle.md`
    margin-bottom: 40px;
  `}
`;

export const DescriptionStyle = styled.div`
  display: flex;
  align-items flex-start;
  flex-wrap: nowrap;
  margin-bottom: 30px;
  p {
    margin: 10px 0 0 20px;
    ${typography.Body2}
    ${ MediaStyle.md`
      margin-left: 30px;
    `}
  }
  strong {
    color: ${basic.secondary};
  }
`;

export const RegRowStyle = GridRowStyle.extend`
  flex-direction: column;
  display: block;
  ${ MediaStyle.md`
    display: flex;
    flex-direction: row;
    flew-wrap: nowrap;
    margin-top: 15px;
  ` }
`;

export const RegColStyle = GridColStyle.extend`
  ${ MediaStyle.md`
    width: ${props => props.half ? '53%' : 'auto'};
    margin: ${props => props.half ? '10px 5px' : '10px 20px'};
    flex: ${props => props.half && 'none'};
    flex-grow: ${props => !props.half && '1'};
    flex-shrink: ${props => !props.half && '1'};
    flex-basis:${props => !props.half && '0'}; 
  ` }
`;


export const GreenWrapperStyle = styled.div`
  background: ${basic.greyGreen};
  padding: 20px;
  ${ MediaStyle.md`
    padding: 30px;
  ` }
`;

export const FieldWrapperStyle = styled.div`
  margin-bottom: 15px;
  label {
    display: block;
    margin-bottom: 10px;
    span {
      color: ${status.rejected};
    }
  }
`;


// WEBPACK FOOTER //
// ./src/components/completeRegistration/style.js